import React, { FC } from 'react';

import cn from 'classnames';

import { useTranslations } from '../../context/translations';
import { LandingPageJsonKeys } from '../../service/contentful/keys';
import styles from './Graph.module.css';

const Graph: FC = () => {
  const { json } = useTranslations();
  return (
    <div className={styles.graph_wrapper}>
      <div className={styles.graph_content}>
        <div className={cn(styles.graph_item, styles.first_item)}>
          {json(LandingPageJsonKeys.GraphJson, 'percent_1')}
        </div>
        <div className={cn(styles.graph_item, styles.second_item)}>
          {json(LandingPageJsonKeys.GraphJson, 'percent_2')}
        </div>
        <div className={cn(styles.graph_item, styles.third_item)}>
          {json(LandingPageJsonKeys.GraphJson, 'percent_3')}
        </div>
      </div>
      <div className={styles.graph_axis_container}>
        <div className={styles.graph_axis} />
      </div>
      <div className={styles.graph_legend_container}>
        <div
          className={cn(styles.graph_legend_item, styles.graph_legend_first)}
        >
          {json(LandingPageJsonKeys.GraphJson, 'position_label_1')}
        </div>
        <div
          className={cn(styles.graph_legend_item, styles.graph_legend_second)}
        >
          {json(LandingPageJsonKeys.GraphJson, 'position_label_2')}
        </div>
        <div
          className={cn(styles.graph_legend_item, styles.graph_legend_third)}
        >
          {json(LandingPageJsonKeys.GraphJson, 'position_label_3')}
        </div>
        <div
          className={cn(styles.graph_legend_item, styles.graph_legend_fourth)}
        >
          {json(LandingPageJsonKeys.GraphJson, 'position_label_4')}
        </div>
      </div>
    </div>
  );
};

export default Graph;
